<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-lg-3 col-md-3 col-sm-6" *ngIf="lstDealers && lstDealers.length > 0;">
      <div class="relative w-100">
        <app-dealer-searchbox-dropdown [dealerList]="lstDealers" [ngModel]="dealerSelected"
          [selectedDealer]="commRequestModel.dealerId" ngDefaultControl name="dealerDropdown"
          (onSelectDealer)="onDealerSelected($event)" placeholder="Search Dealer">
        </app-dealer-searchbox-dropdown>
      </div>
    </div>
    <div class='col-lg-3 col-md-3 col-sm-6'>
      <div class="date">
        <input bsDaterangepicker name="dateSelection" [bsConfig]="myDateRangePickerOptions" class="form-control" 
        [(ngModel)]="createdDate" (ngModelChange)="onDateRangeChanged($event)" required/>
      </div>
    </div>
    <div class='col-lg-1 col-md-1 col-sm-2'>
      <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblStatus' | translate }}"
        [(ngModel)]="commRequestModel.status" (change)="onStatusChange()" [clearable]="false">
        <ng-option *ngFor="let st of lstStatusType; let i = index" [value]="i">
          {{st?st:'All'}}</ng-option>
      </ng-select>
    </div>
    <div class='col-lg-2 col-md-2 col-sm-4'>
      <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblChannel' | translate }}"
        [(ngModel)]="commRequestModel.channelType" (change)="onChannelChange()" [clearable]="false">
        <ng-option *ngFor="let ct of lstChannelType;" [value]="ct.id" translate>
          {{ct.label}}</ng-option>
      </ng-select>
    </div>
    <div
      class="col-xl-3 col-lg-3 col-md-12 relative flmid mt-3 mt-lg-0 justify-content-md-end justify-content-lg-start">
      <button type="button" (click)="onClickChangeView(false)"
        [ngClass]="isTodayViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'" class="mr-sm-2"
        translate>lblSATodayView
      </button>
      <button type="button" (click)="onClickChangeView(true)" [ngClass]="isWeekViewOn ? 'btn btn-primary' : 'btn btn-outline-primary'"
        class="" translate>lblSAWeekView
      </button>
      <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" aria-label="Center Align"
        (click)='GetCommunicationList()'>
        <em class="fas fa-sync fa-lg"></em>
      </a>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card ">
        <div class="card-header d-flex justify-content-between" translate>
          lblSMSLogScreen
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
            totalCount
            }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>
        <div class="table-responsive max-h254" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
          <table class="tablest1 fixed-header">
            <thead>
              <tr>
                <th style="width: 5%" scope="col">#</th>
                <th scope="col" sortable="LicensePlateNo" (sort)="onSort($event)" translate>lblRegNumber</th>
                <th scope="col" sortable="WorkOrderNo" (sort)="onSort($event)" translate>lblWoNo</th>
                <th scope="col" sortable="Sender" (sort)="onSort($event)" translate>lblSender</th>
                <th scope="col" sortable="Receiver" (sort)="onSort($event)" translate>lblReceiver</th>
                <th scope="col" sortable="DealerName" (sort)="onSort($event)" translate>lblDealerName</th>
                <th scope="col" sortable="Channel" (sort)="onSort($event)" translate>lblChannel</th>
                <th scope="col" sortable="MsgSubject" (sort)="onSort($event)" translate>lblSubject</th>
                <th scope="col" sortable="Status" (sort)="onSort($event)" translate>lblStatus</th>
                <th scope="col" sortable="OnDate" (sort)="onSort($event)" translate>lblDate</th>
                <th style="width: 5%" class="text-center" scope="col" translate>lblView</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="lstCommunication?.length > 0; else load_else">
                <tr *ngFor="let comm of lstCommunication; let i=index">
                  <td>{{i+1}}</td>
                  <td>
                    <div class="flmid">
                      <div class="licplate LPNo d-flex">
                        <span class="icn-flag" [ngClass]="licensePlateClass"></span> {{comm.licensePlateNo}}
                      </div>
                    </div>
                  </td>
                  <td>
                    <ngb-highlight [result]="comm.workOrderNo"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="comm.sentBy"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="comm.receiver"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="comm.dealerName"></ngb-highlight>
                  </td>
                  <td translate>
                    lbl{{comm.channel}}
                  </td>
                  <td>
                    <ngb-highlight [result]="comm.msgSubject"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="lstStatusType[comm.status]"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="getLocalDate(comm.onDate) | date:'short'"></ngb-highlight>
                  </td>
                  <td class="nowrap text-center">
                    <a class="btn btn-ico" ngbTooltip="{{'lblView' | translate}}"
                      (click)="ViewDetails(viewDetailContent, comm)">
                      <em class="far fa-eye fa-lg"></em>
                    </a>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="11" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Popup for View Communication detail -->
<ng-template #viewDetailContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>lbl{{communicationDetail.channel}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.close('Cross click')"><span
        aria-hidden="true">×</span></button>
  </div>
  <div class="modal-body table-responsive">
    <div class="card scrollbar">
      <div class="card-content">
        <div class="card-body">
          <div class="row">
            <div class="col-12 af-form-group">
              <div class="row">
                <div class="col">
                  <div class="flmid">
                    <div class="licplate LPNo d-flex">
                      <span class="icn-flag" [ngClass]="licensePlateClass"></span> {{communicationDetail.licensePlateNo}}
                    </div>
                  </div>
                </div>
                <div class="col">
                  <strong translate class="font-14">lblWoNo</strong>
                  <div>{{communicationDetail.workOrderNo}}</div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col">
                  <strong translate class="font-14">lblDate</strong>
                  <div>{{getLocalDate(communicationDetail.onDate) | date:'short'}}</div>
                </div>
                <div class="col">
                  <strong translate class="font-14">lblStatus</strong>
                  <div>{{lstStatusType[communicationDetail.status]}}</div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col">
                  <strong translate class="font-14">lblSender</strong>
                  <div>{{communicationDetail.sentBy}}</div>
                </div>
                <div class="col">
                  <strong translate class="font-14">lblReceiver</strong>
                  <div>{{communicationDetail.receiver}}</div>
                </div>
              </div>
              <div class="row mt-3" *ngIf="communicationDetail.channel != 'SMS'">
                <div class="col">
                  <strong translate class="font-14">lblSubject</strong>
                  <div>{{communicationDetail.msgSubject}}</div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col">
                  <strong translate class="font-14">lblBody</strong>
                  <div [innerHtml]="communicationDetail.msgBodyHtml" class="comm-body-scroll form-control"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-md" (click)="modal.close('Cancel click')"
      translate>lblCancel</button>
  </div>
</ng-template>
